import React from 'react';

// @ts-ignore
import CircleSpinner from 'components/CircleSpinner';
import Row from 'components/Row';
import Text from 'components/Text';

export default function CSVUploadLoadingState(props: { text: string }) {
  return (
    <div>
      <Row size="small">
        <CircleSpinner size="large" />
      </Row>
      <Text color="mascot" size="large" data-test="loading-text">
        {props.text}
      </Text>
    </div>
  );
}
